import { IMember } from "@wingspanhq/users/dist/lib/interfaces";

export const selectorMemberCountry = (member: IMember) =>
  member.profile.address?.country || "US";
